var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSukses(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-4.54389e-06 41.2646C-4.44922e-06 39.0375 0.168245 36.7685 0.546814 34.4994C3.32299 17.3135 17.288 3.32109 34.4918 0.547808C56.6171 -3.02384 77.4805 11.2207 81.9392 33.0288C82.2757 34.7516 81.182 36.3903 79.4995 36.7685C77.7749 37.1047 76.1344 36.0121 75.7559 34.3314C71.9702 15.8849 54.3036 3.7833 35.5014 6.85071C20.9475 9.2038 9.12772 21.0112 6.77218 35.5499C3.74362 54.4166 15.8999 72.0227 34.4498 75.7625C36.1744 76.0986 37.268 77.7794 36.9315 79.4602C36.595 81.183 34.9125 82.2755 33.2299 81.9393C13.5864 77.9475 -5.37454e-06 60.8036 -4.54389e-06 41.2646Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8153 54.9148C37.7984 54.9148 36.8323 54.5085 36.1204 53.7974L28.0867 45.8228C26.6122 44.3498 26.5613 41.9117 28.0867 40.4387C29.5613 38.9657 32.0019 38.9149 33.4764 40.4387L38.6119 45.518L53.3573 28.2991C54.7302 26.6738 57.12 26.5214 58.747 27.8928C60.3233 29.2642 60.5267 31.6515 59.1538 33.2769L41.7644 53.5942C41.0525 54.4069 40.0865 54.864 39.0187 54.9148C38.917 54.9148 38.8661 54.9148 38.8153 54.9148Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSukses);
export default __webpack_public_path__ + "static/media/Sukses.c51c70b81a7633783cfbec0b93db7ad2.svg";
export { ForwardRef as ReactComponent };